import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Document } from '../Icons';
import * as Utils from '../../utils';

const ArticleCard = ({
  type,
  policy,
  tag,
  title,
  thumbnail,
  author,
  read_time: readTime,
  date,
  permalink,
  size,
}) => {
  if (!permalink || !title) {
    return null;
  }

  const headerItems = [type, policy, tag].filter((e) => !!e);
  const minsLabel = readTime === 1 ? 'min' : 'mins';
  const hasHeaderItems = !!headerItems?.length;
  const sizeClass = size ? `article-card--${size}` : '';

  return (
    <div className={classnames('article-card', { [sizeClass]: sizeClass })}>
      <a href={permalink} className='article-card__link' rel='noreferrer' target='_blank'>
        {thumbnail && (
          <div className='article-card__media'>
            <img src={Utils.getImageURL(thumbnail)} alt={title} className='article-card__img' />
          </div>
        )}
        <div className='article-card__content'>
          <div className='article-card__header'>
            <div className='article-card__icon'>
              <Document className='article-card__icon-document' />
            </div>
            {hasHeaderItems && (
              <div className='article-card__terms'>
                <div className='article-card__terms-container'>
                  {headerItems.map((item, index) => {
                    return (
                      <span
                        key={`article-card__terms-item-${index}`}
                        className='article-card__terms-item'
                      >
                        {item}
                      </span>
                    );
                  })}
                </div>
              </div>
            )}
            {date && <div className='article-card__date'>{date}</div>}
          </div>

          <div className='article-card__body'>
            <div className='article-card__title'>{title}</div>
          </div>

          {(author || readTime) && (
            <div className='article-card__footer'>
              {author && (
                <div className='article-card__author'>
                  <div className='article-card__author-container'>
                    By <strong>{author}</strong>
                  </div>
                </div>
              )}
              {readTime && (
                <div
                  className={classnames('article-card__read-time', {
                    'article-card__read-time--without-border': !author,
                  })}
                >
                  Read time <strong>{readTime}</strong> {minsLabel}
                </div>
              )}
            </div>
          )}
        </div>
      </a>
    </div>
  );
};

ArticleCard.propTypes = {
  type: PropTypes.string,
  policy: PropTypes.string,
  tag: PropTypes.string,
  title: PropTypes.string,
  thumbnail: PropTypes.string,
  author: PropTypes.string,
  read_time: PropTypes.number,
  date: PropTypes.string,
  permalink: PropTypes.string,
  size: PropTypes.string,
};

export default ArticleCard;
